enum LiveState {
  NONE = 'none',
  INITIAL = 'initial',
  NOT_SYNC = 'not-sync',
  SYNC = 'sync',
  ENDED = 'ended',
}

export default LiveState;



// WEBPACK FOOTER //
// ./constants/live-state.ts